import axios from "../../config/axiosConfig";
import {
  JOB_YARN_STOCK_REPORT_REQUEST,
  JOB_YARN_STOCK_REPORT_SUCCESS,
  JOB_YARN_STOCK_REPORT_FAILURE,
  JOB_YARN_STOCK_FILTER_REPORT_REQUEST,
  JOB_YARN_STOCK_FILTER_REPORT_SUCCESS,
  JOB_YARN_STOCK_FILTER_REPORT_FAILURE,
} from "../types/job-yarn-stock-report-types";

export const getJobYarnStockReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType, 
        selectedItems: params?.selectedItems, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      const data = requestParams; 

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/job-yarn-stock-report/getReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.post('/job-yarn-stock-report/getReport', data, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: JOB_YARN_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Job Yarn Register Report:", error);
        dispatch({ type: JOB_YARN_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Job Yarn Register Report:", error);
      dispatch({ type: JOB_YARN_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getJobYarnFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_STOCK_FILTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        // commanMaster: auth?.company?.Common_Master,
      };

      // Merge default params with provided params
      const requestParams = { ...defaultParams };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/job-yarn-stock-report/getJobYarnFilterDetail?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: JOB_YARN_STOCK_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Job Yarn Register Report:", error);
        dispatch({ type: JOB_YARN_STOCK_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Job Yarn Register Report:", error);
      dispatch({ type: JOB_YARN_STOCK_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearJobYarnStockReport = () => {
  return async (dispatch) => {
    dispatch({ type: JOB_YARN_STOCK_REPORT_SUCCESS, payload: {} });
  }
}
